import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Navigation, Router } from '@angular/router';
import { Thumbnail } from 'src/app/interfaces/thumbnails.interface';
import { AulaOnlineService } from 'src/app/services/aula-online/aula-online.service';

interface MenuItem {
  image: string;
  text: string;
  url: string;
}

interface VideoItem{
  id: number;
  image: string;
  text: string;
}

@Component({
  selector: 'app-videos',
  templateUrl: './videos.component.html',
  styleUrls: ['./videos.component.scss']
  //template: "<div #videoContainer></div>"
 
})

export class VideosComponent implements OnInit {
  @ViewChild('videoContainer', { static: false }) videoContainer: ElementRef;
  
  @Input() matriculaCompleta;
  cursoId: number = null;
  nomeAulaOnline: string = null;
  error: boolean = false;
  materias: any[] = [];
  matriculaId: number = null;
  isDesktop = false;
  aluno: string = null;
  videos: any[] = [];
  thumbnails: Thumbnail[] = [];
  
  itemsPerPage = 12;
  currentPageIndex = 0;

  videoUrl = 'https://www.youtube.com/embed/{video_id}';
  videoHtml: string;
  iframe = document.createElement('iframe');
  iframeElement: HTMLIFrameElement;

  hideButtonsOnMobile = false;

  menuItems: MenuItem[] = [
    { image: '../../../assets/home.png', text: 'Home', url:'initial' },
    { image: '../../../assets/minhas_aulas2.png', text: 'Minhas aulas', url:'disciplinas' },
    { image: '../../../assets/icon_simulados.png', text: 'Simulado', url:'simulados' },
    { image: '../../../assets/financeiro2.png', text: 'Financeiro', url:'alunos/matricula-aluno/aluno-financeiro-contrato' },
    { image: '../../../assets/documentos2.png', text: 'Documentos', url:'alunos/matricula-aluno/aluno-documentos' },
    { image: '../../../assets/conteudo.png', text: 'Conteúdo' , url:'alunos/matricula-aluno/conteudo-digital'},
    { image: '../../../assets/whatsapp_icon2.png', text: 'Canal WhatsApp', url:'whatsapp' },
    { image: '../../../assets/youtube2.png', text: 'YouTube', url: 'videos' },
    // { image: '../../../assets/eja_encceja2.png', text: 'Provas', url: 'alunos/eja-encceja' },
    { image: '../../../assets/sair.png', text: 'Sair', url: 'login' },
  ];

  videoItems: VideoItem[] = [
    { id: 1, image: '014', text: 'Ao Vivo'},
    { id: 2, image: '015', text: 'Dicas de Estudo'},
    { id: 3, image: '016', text: 'Inscreva-se'}
  ];   
    
  logoLocalStorage = "";
  cursoLocalStorage = "";
  unidadeLocalStorage = "";
  matriculaCompletaStorage = "";

  constructor(
    private router: Router,
    private breakpointObserver: BreakpointObserver,
    private aulaOnlineService: AulaOnlineService,
    private sanitizer: DomSanitizer,
  ) {
    
    

    // Get State
    this.logoLocalStorage = window.localStorage.getItem('logoLocalStorage');
    this.cursoLocalStorage = window.localStorage.getItem('cursoLocalStorage');
    this.unidadeLocalStorage = window.localStorage.getItem('unidadeLocalStorage');
    this.cursoId = parseInt(window.localStorage.getItem('cursoIdLocalStorage'));
    this.matriculaCompletaStorage = JSON.parse(window.localStorage.getItem('matriculaCompletaStorage'));  
    this.matriculaId = parseInt(window.localStorage.getItem('matriculaIdLocalStorage'))
    

    const currentNavigation: Navigation = this.router.getCurrentNavigation();
    if (currentNavigation && currentNavigation.extras && currentNavigation.extras.state) {
      const state = currentNavigation.extras.state;
      this.matriculaCompleta = state.matriculaCompleta;
      this.matriculaId = state.matriculaId;
    }
   }

  ngOnInit(): void {
    this.checkScreenSize();

    this.aluno = window.localStorage.getItem('alunoStorage');
    const nomes = this.aluno.split(" ");
    const primeiroNome = nomes[0];
    const ultimoNome = nomes[nomes.length - 1];
    this.aluno = primeiroNome + ' ' + ultimoNome
    
    this.breakpointObserver.observe(['(min-width: 768px)']).subscribe(result => {
      this.isDesktop = result.matches;
    });
  }

  ngOnDestroy() {
    window.removeEventListener('beforeunload', this.removeIframe);
  }

  checkScreenSize() {
    // Define hideButtonsOnMobile como true se a tela for menor que 768px
    this.hideButtonsOnMobile = window.innerWidth < 768;
  }

  visualizaAula(matriculaId: number, materiaId: string): void{
    window.localStorage.setItem('materiaIdLocalStorage', materiaId);
    window.localStorage.setItem('materiaIdStorage', materiaId);
    window.localStorage.setItem('videosLocalStorage', 'true');
    
    const materiaString = JSON.stringify(this.materias);
    window.localStorage.setItem('materiaStorage', materiaString);
    this.router.navigate(['/aulas']);
  }



  linkSeletor(url: string, aulaId: number): void {
    var cursoId = Number(window.localStorage.getItem('cursoIdLocalStorage'));
    switch (url) {
      case 'whatsapp':
        window.open("https://whatsapp.com/channel/0029Va56Dv72kNFxI2ufVE09");
        break;
      default:
        this.router.navigate([`/${url}`], { state: { aulaId } });
        break
    }
  }

  removerAcentos(texto: string): string {
    return texto.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  carregaThumb(id: number) {
    
    switch (id) {
      case 1:
        this.getVideoAoVivo();
        break;
      case 2:
        this.getVideoDicas();
        break;
      default:
        window.open('https://www.youtube.com/@SupletivoPreparatorio','_blank')
        break;
    }
  }

  async getVideoAoVivo() {
    try {
      const val = await this.aulaOnlineService.getVideoAoViveo().toPromise();
      this.thumbnails = val;
      
      var divThumb = document.getElementById("thumb");
      divThumb.style.display = "block";
      var divBotoes = document.getElementById('nBotoes');
      if (this.thumbnails.length > this.itemsPerPage) {
        divBotoes.style.visibility = 'visible';
      } else {
        divBotoes.style.visibility = 'hidden';
      }

      if (window.innerWidth < 768) {
        var divContainer = document.getElementById('card');
        divContainer.style.display = 'none';
        var divBack = document.getElementById('divBackButton');
        divBack.style.display = 'block';
      }

      this.currentPageIndex = 0
      this.getItems();
      return val;
    } catch (err) {
      console.error(err);
      throw err;
    }
  }
  
  
  get maxPageIndex() {
    return Math.ceil(this.thumbnails.length / this.itemsPerPage) - 1;
  }

  get isFirstPage() {
    return this.currentPageIndex === 0;
  }

  get isLastPage() {
    return this.currentPageIndex === this.maxPageIndex;
  }

  previousPage() {
    if (!this.isFirstPage) {
      this.currentPageIndex--;
    }
  }

  nextPage() {
    if (!this.isLastPage) {
      this.currentPageIndex++;
    }
  }


  async getVideoDicas() {
    try {
      const val = await this.aulaOnlineService.getVideoDicasDeEstudo().toPromise();
      this.thumbnails = val;
      
      var divThumb = document.getElementById("thumb");
      divThumb.style.display = "block";
      var divBotoes = document.getElementById('nBotoes');
      
      if (this.thumbnails.length > this.itemsPerPage) {
        divBotoes.style.visibility = 'visible';
      } else {
        divBotoes.style.visibility = 'hidden';
      }

      if (window.innerWidth < 768) {
        var divContainer = document.getElementById('card');
        divContainer.style.display = 'none';
        var divBack = document.getElementById('divBackButton');
        divBack.style.display = 'block';
      }

      this.currentPageIndex = 0
      this.getItems();
      return val;
    } catch (err) {
      console.error(err);
      throw err;
    }
  
  }

  getItems(): any[] {
    return this.thumbnails.slice(this.currentPageIndex * this.itemsPerPage, (this.currentPageIndex + 1) * this.itemsPerPage);
  }

  
  carregaVideo(id: string) {
    var divContainer = document.getElementById('card');
    divContainer.style.display = 'none';
    var divThumb = document.getElementById("thumb");
    divThumb.style.display = "none";
    var divBotoes = document.getElementById('nBotoes');
    divBotoes.style.visibility = 'hidden';
    
    var divBack = document.getElementById('divBackThumb');
    divBack.style.display = 'block';

    var divBack = document.getElementById('divBackButton');
      divBack.style.display = 'none';
    
    this.videoUrl = `https://www.youtube.com/embed/${id}`;
    const loadingMessage = document.getElementById('loading-message');

    this.iframe.src = this.videoUrl;
    this.iframe.allowFullscreen = true;
    this.iframe.setAttribute('frameborder', '0');
    this.videoContainer.nativeElement.appendChild(this.iframe);
    this.iframeElement = this.iframe;
    this.iframeElement.style.display = 'block';
    this.iframeElement.style.height = 'inherit';
    this.iframeElement.style.width = 'inherit' 
    this.iframeElement.style.left = '7px';
    this.iframeElement.style.position = 'absolute';
    this.iframeElement.addEventListener('load', () => {
      // Remove a mensagem de carregamento
      if (loadingMessage) {
        loadingMessage.remove();
      }
    });
  }

  retornaThumb() {
    var divContainer = document.getElementById('card');
    var divBack = document.getElementById('divBackThumb');
    var divBackButton = document.getElementById('divBackButton');
    if (window.innerWidth < 768) {
      divContainer.style.display = 'none';
      divBack.style.display = 'none';
      divBackButton.style.display = 'block';
    } else {
      divContainer.style.display = 'block';
      divBack.style.display = 'none';
      divBackButton.style.display = 'none';
    }
    var divThumb = document.getElementById("thumb");
    divThumb.style.display = "block";
    var divBotoes = document.getElementById('nBotoes');
    divBotoes.style.visibility = 'visible';
    
    
    this.iframeElement.style.display = 'none';
    this.removeIframe();
  }

  retornaButton() {
    var divContainer = document.getElementById('card');
    if (window.innerWidth < 768) {
      divContainer.style.display = 'block';
    } 
    
    var divThumb = document.getElementById("thumb");
    divThumb.style.display = "none";
    var divBotoes = document.getElementById('nBotoes');
    divBotoes.style.visibility = 'hidden';
    var divBack = document.getElementById('divBackButton');
    divBack.style.display = 'none';
    
  }

  removeIframe = () => {
    if (this.iframe && this.iframe.parentNode) {
      this.iframe.parentNode.removeChild(this.iframe);
    }
  };
}
